import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';
import Icon from 'components/Icons/Icon';

const Group = ({ groupDetails, index, numOfGroups, handleShowGroupOnHover, handleCurrentGroupId }) => {
  
  const { darkMode } = useSelector((state) => state.app)
  const { id, name, path, isRoot } = groupDetails;

  const [isFocused, setIsFocused] = useState(false);
  const [groupLineage, setGroupLineage] = useState("");

  useEffect(() => {

    if (isRoot) {
      const rootMessage = `
        This site is only in the Root Group and 
        therefore not visible to the end user.
        Add it to a group if you want to be able to see it.
      `

      const renderMessage = () => {
        return (
          <div id="root-group-tips-box" className='tips-box m-0'>
            <h6 className="d-flex align-items-center flex-row" id="tip-box-header">
              <Icon className="fas fa-lightbulb" />
              <span className="ml-2">Helpful Tips:</span>
            </h6>
            <span id="tip-box-body">
              {/* <span id="tip-box-sub-header">
                What is the <span className="site-ref">Site Ref</span> for <span className="selected-mobile-app">{selectedMobileApp}</span>?
              </span> */}
              <p className="tip-box-text-body">
                {rootMessage}
              </p>
            </span>
          </div>
        )
      }

      setGroupLineage(renderMessage());

      return;
    }

    const formattedPath = path?.map((group, index) => {
    
      // generate correct indentation level for groups 
      // at their depth in group path -------------->
      const indentation = [];
      const addIndentation = () => {
        let i = 0;
        while (i < index) {
          indentation.push("\u00A0\u00A0\u00A0");
          i++;
        }
        return;
      }
      addIndentation();
      // -------------------------------------------|

      return (
        <div 
          key={`tooltip-description-${index}`}
          className='d-flex flex-row flex-nowrap'
        >
          {index !== 0 ?
            <span>
              {indentation.map(indent => indent)}
            </span>
          :
            null
          }
          <span className={name === group?.name ? "font-weight-bold" : ""}>
            {group?.name}
          </span>
        </div>
      )
    })

    setGroupLineage(formattedPath);
  }, [path, isRoot, name])

  const enableHover = () => {
    setIsFocused(true);
    handleCurrentGroupId(id);
    handleShowGroupOnHover();
  }
  
  const disableHover = () => {
    setIsFocused(false);
    handleCurrentGroupId(id);
    handleShowGroupOnHover();
  }

  return (
      <div
        data-intercom-target={"enterprise-association-groups"}
        name="groups"
        type="text"
        onMouseEnter={enableHover}
        onMouseLeave={disableHover}
        onChange={() => {return}}
      >
        {
          isFocused ?
          <Tooltip
            id={`group-wrapper-${index}`}
            placement="top"
            description={groupLineage}
            white={!darkMode}
            tooltipClassName="w-100"
          >
            <div className="d-flex d-row p-0 m-0 flex-nowrap">
              <span className={`${isFocused ? "group-is-focused" : "group-not-focused"} ${isRoot ? "is-root" : ""}`}>
                {name}
              </span>
              {index === numOfGroups - 1 ?
                null
                  :
                <span className="mr-1">
                  {","}
                </span>
              }
            </div>
          </Tooltip>
        :
          <div className="d-flex d-row p-0 m-0 flex-nowrap">
            <span className={`${isRoot && numOfGroups === 1 ? "is-root" : ""} group-not-focused`}>
              {name}
            </span>
            {index === numOfGroups - 1 ?
              null
                :
              <span className="mr-1">
                {","}
              </span>
            }
          </div>
      }
      </div>
  )
}

export default Group;